// extracted by mini-css-extract-plugin
export default {"banner":"RepPovBanner_banner__bIgS4","aux":"RepPovBanner_aux__p5CCo"};